<template>
  <div class="advisors-faq-compo">
    <div class="main-page">
      <div class="section-2">
        <el-row>
          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
            <div class="left-side" v-for="(link, index) in links" :key="index">
              <div class="tab-btn flex" @click="active_faq_type = link"
                :class="[active_faq_type == link ? 'active-tab-btn' : 'tab-btn']">
                <div>{{ link }}</div>
                <div>+</div>
              </div>
            </div>
          </el-col>

          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
            <div class="faq-right" v-if="active_faq_type == 'General'">
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What are Verified Expert tag on StockAnts?</li>
                </ul>
                <p class="faq-p">
                  StockAnts can be onboarded by market experts to build their advisory
                  track record and increase their business. Market experts needs to do
                  eKYC with their SEBI Registered number and upload their certificate.
                  Those marker experts who have completed their eKYC with StockAnts will
                  be tagged as a verified Expert.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How is verified expert different from non-verified expert?</li>
                </ul>
                <p class="faq-p">
                  Verified expert will be tagged with verified tick mark to get trust and
                  visibility. They will be ranked in top experts and benchmarked with
                  their performance.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What benefits from contributing price estimates on StockAnts?</li>
                </ul>
                <p class="faq-p">
                  Market experts on StockAnts get organic visibility as we are connected
                  with broker. Get access to my dashboard with Price estimate tracking, get
                  benchmarked with other experts based on performance and store access to
                  their advisory share with their clients.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Where will my price estimates get displayed?</li>
                </ul>
                <p class="faq-p">
                  You can track your estimates in “My View” on real time basis. It will be
                  displayed in “My View” tab. As we are connected with various broker,
                  your name and price estimates will be followed by reached retail users
                  from various brokers.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How many times can I change my Price Estimate?</li>
                </ul>
                <p class="faq-p">
                  Estimates shared by Market Participants are based on market sentiments
                  in the short-term period, which can lead to changes for many reasons.
                  StockAnts allows Users to change their Price estimates, every time the
                  user updates the Price estimate the accuracy will be reduced by 10% for
                  every update. If the week’s result is on Friday, then the user cannot
                  change the price estimates post-Wednesday. If the month’s results are on
                  the 4th week of the month, then the user cannot change estimates post
                  the 3rd week of that month. If quarter results are on the last week of
                  the quarter, then the user cannot change estimates post 10th-week
                  results.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>I have other questions not answered here</li>
                </ul>
                <p class="faq-p">
                  Feedback is an extremely important part of our product and business
                  development process, so please don’t be shy about providing it (whether
                  good, bad, or indifferent). For general feedback please email
                  admin@stockants.com.
                </p>
              </div>
            </div>

            <div class="faq-right" v-if="active_faq_type == 'StockAnts Terms'">
              <div class="text-right">
                <div class="check-vdo" @click="
                  activeVideo = 'https://www.youtube-nocookie.com/embed/d7KnQHgQsPc';
                videoDialog = true;
                ">
                  Check Video
                </div>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How is Accuracy calculated?</li>
                </ul>
                <p class="faq-p">
                  Accuracy is computed by calculating the deviation from the target price
                  relative to the reco price. The target price is compared with the actual
                  price(Highest/lowest depending on the type of opinion- buy/sell)
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How is the Success rate calculated?</li>
                </ul>
                <p class="faq-p">
                  Success at StockAnts is defined as the achievement of the target price
                  within the chosen time frame. We recommend using the Success Rate along
                  with the Accuracy for a true evaluation of performance. If CMP is 100/-
                  and your estimate for the week is 115/-, If the target is achieved
                  during the week success rate will be 100%. If the price does not reach
                  the target price success rate will be 0%
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Why is my Accuracy lower even at a 100% Success Rate?</li>
                </ul>
                <p class="faq-p">
                  Success Rate is binary whether the target is achieved or not achieved
                  i.e 100% or 0%, whereas Accuracy measures the estimates with Actual
                  Market performance. For proper evaluation always look at success rate
                  along with accuracy.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What are AntEstimates and how it is calculated?</li>
                </ul>
                <p class="faq-p">
                  AntEstimates represent the collective view or consensus of the market
                  based on the various estimates provided by the investor community. The
                  data cleansing algorithms weed out frivolous estimates and utilize the
                  normalized data to arrive at the market consensus.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How to read a performance wheel? (StockAnts terms)</li>
                </ul>
                <p class="faq-p">
                  Performance is measured by two critical parameters, Success Rate on
                  achieving the target estimate provided and Accuracy based on the
                  variance of the estimates from the Actual Market prices at the end of
                  the estimated period (Week/ Month/ Quarter). The Performance Wheel
                  indicates the achievement of the target in a number of days and the
                  potential to achieve more returns over the estimated period.
                  Recommendation status in performance wheel depicts target achieved,
                  target not achieved, recommendation updated, recommendation closed, live
                  recommendation, yet to live and stop-loss triggered.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                    What is the difference between a total recommendation and live
                    recommendations?
                  </li>
                </ul>
                <p class="faq-p">
                  Recommendations are considered ‘live’ the target is not achieved or till
                  the elapse of the time period for which the estimate is provided.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Short term is defined as?</li>
                </ul>
                <p class="faq-p">
                  StockAnts considers Weekly, Monthly, and Quarterly estimates as Short
                  Term. Investors can provide estimates for a period of Six Months under
                  this category. StockAnts allows sharing recommendations for short term –
                  current week, current month, current quarter, next quarter. Any target
                  period above 6 months will be considered as long term.
                </p>
              </div>
            </div>

            <div class="faq-right" v-if="active_faq_type == 'Rankboard'">
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How is the Overall Rating calculated?</li>
                </ul>
                <p class="faq-p">
                  Overall Rating is calculated on the basis of Annualised ROI, Accuracy,
                  and Success rate.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How is Ranking done?</li>
                </ul>
                <p class="faq-p">
                  StockAnts considers a multi-factor model to ‘Rank’ contributors to
                  provide confidence to the investors. Ranking will be done on the basis
                  of overall rating (Highest to lowest)You will be ranked on StockAnts
                  when you have a minimum of 30 Total Recommendations and 1 Live
                  Recommendation.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Why is my name not displayed on the Rank board?</li>
                </ul>
                <p class="faq-p">
                  Your name will be only displayed when you fulfill the following criteria
                  – you have a minimum of 30 Total Recommendations and 1 Live
                  Recommendation, Positive ROI, and Active for 1 Month on Platform.
                </p>
              </div>
              <!-- <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li></li>
                </ul>
                <p class="faq-p"></p>
              </div> -->
            </div>

            <div class="faq-right" v-if="active_faq_type == 'Plans'">
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What is StockAnts Lite Plan?</li>
                </ul>
                <p class="faq-p">
                  StockAnts Lite plan is a free plan. Benefits – Publish recommendations
                  and get Price estimate tracking, get data insights based on performance
                  metrics in simple visualization format, access to the latest 5
                  recommendations from market experts for
                  <a href="/plans">Check Plans.</a>
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What is StockAnts Day Plan?</li>
                </ul>
                <p class="faq-p">
                  Day pass gives you first hands-on experience of StockAnts. We don’t want
                  to oblige users to subscribe for 1 month and make it obligatory to use
                  StockAnts platform. Users can checkout StockAnts platform as when
                  required without any commitment and decide on trade and investment.
                  <a href="/plans">Check Plans.</a>
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What is StockAnts Premium?</li>
                </ul>
                <p class="faq-p">
                  StockAnts Premium plan is access to market expert’s recommendations with
                  insightful Price estimate tracking. StockAnts premium includes all benefits
                  of StockAnts Lite plus unlimited access to market experts
                  recommendations and Price estimate tracking with more than 20 filters,
                  Unrestricted access to market experts dashboards, and StockAnts
                  performers with data insight based on performance metrics.<a href="/plans">Check Plans.</a>
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>What is StockAnts Pro?</li>
                </ul>
                <p class="faq-p">
                  StockAnts Pro plan is using StockAnts as a digital store for sharing
                  research data with your clients/community/ groups. StockAnts Pro plan
                  includes all benefits of StockAnts premium plus sharing access to your
                  research data with insightful analytics to your
                  clients/community/groups, bulk recommendation upload facility, single
                  click and share on social media plugins, In trend Stocks newsletter to
                  help you rank higher on StockAnts and users details who have visited
                  your research.
                  <a href="/plans">Check Plans.</a>
                </p>
              </div>
            </div>

            <div class="faq-right" v-if="active_faq_type == 'Earn from StockAnts'">
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                    What is Earn from StockAnts?
                    <el-button class="custom-btn" size="mini"
                      @click="$router.push({ path: '/advisors/expert-side/EFS' })">Check Details</el-button>
                  </li>
                </ul>
                <p class="faq-p">
                  StockAnts provides a platform where market experts can share their
                  expertise by publishing stock recommendations and based on the
                  performance of the given recommendations the user will be rated and
                  after every 12 weeks, the user will earn money based on the ratings.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Is Earn from StockAnts applicable for everyone?</li>
                </ul>
                <p class="faq-p">
                  Earn from StockAnts Programme is curated only for SEBI registered
                  experts (RA & RIA)
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>Earn from StockAnts is live for which segment?</li>
                </ul>
                <p class="faq-p">
                  Earn from StockAnts is live for equity segment as of now, Earn from
                  StockAnts is coming soon for Futures & Options.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                    For how many days an expert has to be active on the platform to earn
                    rewards?
                  </li>
                </ul>
                <p class="faq-p">
                  An expert has to be active for minimum 30days on StockAnts to be
                  eligible for rewards.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                    How many recommendations are necessary to get ranked on the platform?
                  </li>
                </ul>
                <p class="faq-p">
                  1 live recommendation & 30recommendations in a month are necessary to
                  get ranked on the platform.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>On what basis Rating will be given to the experts?</li>
                </ul>
                <p class="faq-p">
                  The rating will be given when an expert has uploaded minimum
                  10recommendations & on the basis of three metrics Return on Investment,
                  Success rate, and accuracy.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>How will the expert get rewards?</li>
                </ul>
                <p class="faq-p">
                  The expert has to add his bank details in My Account –>Bank Details.
                  Once the rating is updated at month end, if you are eligible for the
                  rewards, it will be transferred to expert’s bank account within 7working
                  days.
                </p>
              </div>
              <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>I have other questions not answered here</li>
                </ul>
                <p class="faq-p">
                  Feedback is an extremely important part of our product and business
                  development process, so please don’t be shy about providing it (whether
                  good, bad, or indifferent). For general feedback please email
                  admin@stockants.com.
                </p>
              </div>
              <!-- <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                  </li>
                </ul>
                <p class="faq-p">
                </p>
              </div> -->

              <!-- <div class="special-sec" style="margin-top: 0">
                <ul>
                  <li>
                    Who is eligible to Earn from StockAnts?
                  </li>
                </ul>
                <p class="faq-p">
                  The user needs to fulfill the following criteria –
                </p>
                <p class="faq-p">
                  At any given point in time, you should have 1 live
                  recommendation and at least 30 past recommendations to get
                  ranked on our platform.
                </p>
                <p class="faq-p">
                  Earn from Stockants has a 12week cycle (Financial
                  Quarter-wise). You are mandated to publish a minimum of 10
                  recommendations every week.
                </p>
                <p class="faq-p">
                  The overall performer rating will be based on Annualized ROI,
                  Success rate, and accuracy.
                </p>
                <p class="faq-p">
                  Your overall performer rating will be considered for EFS after
                  every 12week cycle (Financial Quarter-wise).
                </p>
                <p class="faq-p">
                  Rewards are based on overall performer rating and rankings –
                  Top 30 performers are eligible for the reward.
                </p>
              </div> -->
            </div>
          </el-col>

          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">&nbsp; </el-col>
        </el-row>
      </div>
    </div>

    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" center>
        <iframe width="100%" height="600px" :src="activeVideo" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvisorsFaqComponent",

  components: {},

  mixins: [],

  data() {
    return {
      active_faq_type: "General",
      links: [
        "General",
        "StockAnts Terms",
        // "Rankboard",
        "Plans",
        // "Earn from StockAnts",
      ],
      videoDialog: false,
      activeVideo: "",
    };
  },
  mounted() {
    // set usertype for redirection
    localStorage.setItem("UserType", "ADVISOR");
  },
  methods: {},

  computed: {},
};
</script>

<style lang="scss" scoped>
@import "../../css/variable.scss";
@import "../../css/common.scss";

.advisors-faq-compo {
  background-color: #fcfcfb;

  .main-page {
    .section-1 {
      background-image: url("../../assets/images/ExpertLandingPage/footer/advisor/banner1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      height: 400px;
      font-size: 2rem;
      font-weight: 600;
      text-transform: uppercase;
      color: #ffff;
      text-align: center;
      padding-top: 150px;
    }

    .section-2 {

      // padding-left:40px;
      .top-options {
        font-size: 0.9rem;
        font-weight: 500;
        margin-bottom: 60px;
        justify-content: space-around;
        color: rgb(124, 124, 124);

        .tags {
          padding: 7px;
          cursor: pointer;
        }

        .active-tag {
          margin-right: 20px;
          cursor: pointer;
          padding: 7px;
          color: #322e79;
          border-bottom: 2px solid #322e79;
        }
      }

      .check-vdo,
      a {
        font-weight: 600;
        text-decoration: none;
        color: #6da3f3;
        cursor: pointer;
      }

      .faq-right {
        padding-left: 40px;
        border-left: 1px solid #b1afaf;
      }

      .special-sec {
        margin: 40px 0;

        .faq-p {
          margin-left: 40px;
          color: #6d6a6a;
        }
      }

      h1 {
        font-size: 1.6rem;
        font-weight: 600;
      }

      p {
        font-size: 0.9rem;
        color: #6d6a6a;
      }

      .left-side {
        height: 100%;

        .tab-btn {
          justify-content: space-between;
          width: 200px;
          font-weight: 600;
          border: 1px solid;
          padding: 7px 25px;
          margin: 15px auto;
          border-radius: 20px;
          background-color: #ededed;
          border: 1px solid #ededed;
          box-shadow: 0px 8px 9px -9px #716d6d;
          color: gray;
          cursor: pointer;
        }

        .active-tab-btn {
          color: #000;
        }

        .tab-btn:hover {
          background-color: #dfdddd;
          color: #000;
        }
      }

      ul {
        list-style: none;

        li {
          font-size: 1.5rem;
          margin: 10px 0;
          font-weight: 600;
          color: #25246a;
        }

        li::before {
          content: "\2022";
          color: #3dcadd;
          font-weight: bold;
          width: 1em;
          margin-left: -1em;
          font-size: 45px;
          position: relative;
          margin-right: 25px;
          top: 7px;
        }
      }
    }

    @media screen and (max-width: 876px) {
      .section-1 {
        height: 346px;
        font-size: 1.5rem;
      }

      .section-2 {
        padding: 0 70px;

        .faq-right {
          border-left: none;
        }
      }
    }

    @media screen and (max-width: 600px) {
      .section-1 {
        height: 200px;
        padding-top: 80px;
        font-size: 1.2rem;
      }

      .section-2 {
        padding: 0 35px;

        .faq-right {
          padding-left: 0;
        }

        ul li {
          font-size: 1.1rem;
        }
      }
    }

    @media screen and (max-width: 450px) {
      .section-1 {
        height: 134px;
      }

      .section-2 {
        padding: 0 20px;
      }
    }
  }
}
</style>
